//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('fancyCheckbox',
        () => ({
          restrict: 'E',
          transclude: true,
          scope: {
            isIndeterminate: '=?',
            ngDisabled: '=?',
            ngModel: '=',
            ngChecked: '=?',
            onStateChanged: '&?',
          },
          replace: true,
          template: '<div class="fancy-checkbox">' +
                              '<input ng-disabled="ngDisabled" ng-checked="ngChecked" ng-attr-id="label-{{::id}}" type="checkbox" ng-model="ngModel"/>' +
                              '<label ng-class="{ disabled: ngDisabled }" ng-attr-for="label-{{::id}}">' +
                                  '<span class="fancy-checkbox-checkbox-container" ng-class="{ indeterminate: isIndeterminate }"><i class="fa fa-minus">' +
                                  '</i><i class="fa fa-check"></i></span>' +
                                  '<div ng-transclude></div>' +
                              '</label>' +
                          '</div>',
          link(scope) {
            scope.id = _.uniqueId('fancy-checkbox');

            if (scope.onStateChanged) {
              scope.$watch('ngModel', () => {
                scope.onStateChanged();
              });
            }
          },
        }),
    );
})();
